import { useRef, useEffect } from "react";

const ChatInput = ({ placeholder, onSend, disabled, loading }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!disabled && inputRef.current) {
      inputRef.current.focus();
    }
  }, [disabled]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const value = inputRef.current?.value?.trim();
    if (!value || disabled || loading) return;
    onSend(value);
    inputRef.current.value = "";
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="sticky bottom-0 z-10 flex gap-2 border-t border-base-300 bg-base-100 p-3"
    >
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        className="input input-bordered flex-1"
        disabled={disabled || loading}
      />
      <button
        type="submit"
        className="btn btn-primary"
        disabled={disabled || loading}
      >
        {loading ? (
          <span className="loading loading-spinner loading-sm" />
        ) : (
          "Send"
        )}
      </button>
    </form>
  );
};

export default ChatInput;
